import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Lock, User, ShieldCheck, AlertCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const AdminLogin = () => {
  const { login, user, checking } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (checking) return null;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(username.trim(), password);
      navigate('/admin', { replace: true });
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === 'string' ? d : 'Login gagal. Cek kredensial.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a1e3c] via-[#0a3d8f] to-[#0a8f3d] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl p-8 border border-white/20" data-testid="admin-login-card">
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-blue-50 text-[#0a3d8f] mx-auto mb-4">
            <ShieldCheck size={30} />
          </div>
          <h1 className="text-2xl font-extrabold text-center text-gray-900 mb-1">Admin Panel</h1>
          <p className="text-sm text-gray-500 text-center mb-6">JILONG Indonesia · Kelola konten website</p>

          <form onSubmit={onSubmit} className="space-y-4">
            <label className="block">
              <span className="text-xs font-semibold text-gray-700 uppercase tracking-wider">Username</span>
              <div className="mt-1 relative">
                <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text" required autoFocus
                  value={username} onChange={(e) => setUsername(e.target.value)}
                  data-testid="admin-username-input"
                  className="w-full pl-10 pr-3 py-2.5 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#0a3d8f]/20 focus:border-[#0a3d8f]"
                  placeholder="admin"
                />
              </div>
            </label>
            <label className="block">
              <span className="text-xs font-semibold text-gray-700 uppercase tracking-wider">Password</span>
              <div className="mt-1 relative">
                <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="password" required
                  value={password} onChange={(e) => setPassword(e.target.value)}
                  data-testid="admin-password-input"
                  className="w-full pl-10 pr-3 py-2.5 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#0a3d8f]/20 focus:border-[#0a3d8f]"
                  placeholder="••••••••"
                />
              </div>
            </label>

            {error && (
              <div className="flex items-center gap-2 text-xs px-3 py-2 rounded-md bg-red-50 text-red-700 border border-red-200" data-testid="admin-login-error">
                <AlertCircle size={14} /> <span>{error}</span>
              </div>
            )}

            <button
              type="submit" disabled={loading}
              data-testid="admin-login-submit"
              className="w-full bg-[#0a3d8f] text-white font-semibold py-2.5 rounded-md hover:bg-[#082e6b] transition-colors disabled:opacity-60"
            >
              {loading ? 'Memproses...' : 'Masuk'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
